import React, { useEffect, useState } from "react";
import {  Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { RadioContainer } from "../../commons";
import { SearchCancelIcon } from "../../../assets/images";
import useDebounce from "../../../customHooks/useDebounce";
import { isEmailValid } from "../../../utils/commonFunctions";
import { BlobServiceClient } from "@azure/storage-blob";

type RadioTypes = {
  id: string;
  name: string;
};

const RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "1",
    name: "Send with Attachment",
  },
  {
    id: "0",
    name: "Send without Attachment",
  },
];

type AppProps = {
  modal: boolean;
  toggleModal: () => void;
  data: string;
  clientCode?: string;
  currencySign: string | undefined;
  pdfInvoiceId: number | null;
  fileAttachment: number | null;
  customerSingleInvoiceData: any;
  setSendInvoiceEmailInput: React.Dispatch<React.SetStateAction<string>>;
  handlePostComment?: (data?: any) => void;
  handleSendOverdueEmail: (attachment: string) => void;
};

const SendInvoiceEmailModal = ({
  modal,
  toggleModal,
  data,
  clientCode,
  currencySign,
  customerSingleInvoiceData,
  handlePostComment,
  setSendInvoiceEmailInput,
  handleSendOverdueEmail,
  fileAttachment,
  pdfInvoiceId,
}: AppProps) => {
  const [attachment, setAttachment] = useState(RADIO_OPTIONS[0]?.id);
  const [emailError, setEmailError] = useState(true);
  const [disableRadioButton, setDisableRadioButton] = useState("");



  const handleSetRadioValue = (radioValue: string) => {
    if (fileAttachment) setAttachment(radioValue);
  };

  const handleSendEmailInputChange = (data: string) => {
    setSendInvoiceEmailInput(data);
  };

  const handleDeleteSearch = () => {
    setSendInvoiceEmailInput("");
  };
  useEffect(() => {
    if (fileAttachment == 0) {
      setAttachment("0");
      setDisableRadioButton("1");
    } else {
      setDisableRadioButton("");
    }
  }, [fileAttachment]);

  useDebounce(
    () => {
      if (data?.length) setEmailError(isEmailValid(data));
    },
    500,
    [data]
  );


  return (
    <Modal isOpen={modal} toggle={toggleModal} size={"md"}>
      <ModalHeader toggle={toggleModal}>Send invoice email</ModalHeader>
      <ModalBody>
        <div className="row mt-2">
          <div className="col-md-10 position-relative">
            <input
              className={`form-control ${
                data?.trim()?.length && !emailError && !emailError
                  ? "error-border"
                  : null
              }`}
              type="email"
              style={{ paddingRight: "2rem" }}
              value={data}
              onChange={(e: any) => handleSendEmailInputChange(e.target.value)}
              placeholder={data?.length === 0 ? "Enter email address" : ""}
            />
            {!!data?.trim()?.length && !emailError && (
              <>
                <span className="text-danger">Email not valid</span>
              </>
            )}
            {data?.length ? (
              <span style={{ position: "absolute", top: "8px", right: "20px" }}>
                <img
                  src={SearchCancelIcon}
                  alt="cancel-icon"
                  onClick={handleDeleteSearch}
                  style={{ cursor: "pointer" }}
                />
              </span>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="mt-4 mb-5 ml-2">
          <RadioContainer
            optionsList={RADIO_OPTIONS}
            handleSetRadioValue={handleSetRadioValue}
            radioValue={attachment}
            diasableId={disableRadioButton}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="text-right d-flex">
          <span className="pointer form-control" onClick={toggleModal}>
            Cancel
          </span>
          <button
            className="btn btn-primary ml-3"
            color="primary"
            onClick={() => {
              handleSendOverdueEmail(attachment);
            }}
            disabled={!data?.trim()?.length || !emailError}
          >
            Send
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default SendInvoiceEmailModal;
